import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import bbCode from '../components/global/bbCode';
import { markSurveyDone } from '../data/surveyDone';
import Orb from './Orb';

// Every user reply lands in the thread without a `question`, so they count answered questions.
export const answeredCount = (thread) => thread.filter((item) => !item.question && item.msg).length;

// What Ellie is saying now: every message after the respondent's latest reply.
const currentMessages = (thread) => {
  const messages = thread.filter((item) => item.msg);
  let lastReply = -1;
  messages.forEach((item, i) => {
    if (!item.question) lastReply = i;
  });
  return messages.slice(lastReply + 1);
};

const Thinking = () => (
  <div className="v2-thinking" aria-label="Ellie tänker">
    <i />
    <i />
    <i />
  </div>
);

// One question at a time, centred: Ellie's orb, what she says, and the answer options below.
function V2Stage({ cookies, thread, typing, end, surveyName, total, answers }) {
  useEffect(() => {
    if (end) markSurveyDone(cookies, surveyName);
  }, [end, cookies, surveyName]);

  if (end) {
    return (
      <div className="v2-stage">
        <div className="v2-focus v2-focus--end">
          <div className="v2-end__orb">
            <div className="v2-burst" aria-hidden="true">
              {Array.from({ length: 14 }, (_, i) => (
                <i key={i} style={{ '--a': `${i * (360 / 14)}deg`, '--d': `${i % 3}` }} />
              ))}
            </div>
            <Orb size={120} mood="done" />
          </div>
          <div className="v2-end">{bbCode.toReact(end.question || '')}</div>
        </div>
      </div>
    );
  }

  const now = currentMessages(thread);
  const answered = answeredCount(thread);
  return (
    <div className="v2-stage">
      {/* Keyed per step so each question enters fresh. */}
      <div className="v2-focus" key={answered} aria-live="polite">
        <Orb size={64} mood={typing ? 'thinking' : 'idle'} progress={total ? answered / total : null} />
        {now.map((item, i) => (
          <div
            key={item.ts + '_' + i}
            className={i === now.length - 1 ? 'v2-question is-main' : 'v2-question'}
          >
            {bbCode.toReact(item.msg)}
          </div>
        ))}
        {typing && <Thinking />}
        {answers}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  thread: state.thread.thread,
  typing: state.app.thinking === 'robot',
  end: state.app.endQuestion,
  surveyName: state.app.survey.name,
  total: state.app.survey.q_count,
});

export default connect(mapStateToProps)(V2Stage);
